import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { Title, Wrapper } from "components";
import backgroundImage from '../shared/images/bg_contact-shortw.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'gatsby';

const StyledFooter = styled.footer`
  max-width: ${props => props.theme.maxWidth};
  max-width: 100%;
  margin: 0;
  padding-top: 1rem;
  padding-bottom: 2rem;
  padding-left: ${props => props.theme.leftMargin};
  padding-right: ${props => props.theme.leftMargin};
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.darkBlue};
  background: url(${backgroundImage}) no-repeat, ${props => props.theme.colors.darkBlue};
  background-position: right bottom;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    background-position: 83% bottom;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    background-position: center;
  }
`;

const StyledTitle = styled(props => <Title {...props} />)`
  &:before {
    background-color: ${props => props.theme.colors.white};
  }
`;

const FooterSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    flex-direction: row;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-direction: row;
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ContactInformation = styled.div`
  max-width: 95%;
  h3 {
    font-family: 'Canela-Medium"';
    font-size: 2rem;
    height: auto;
    line-height: 2rem;
    font-weight: bold;
    display: flex;
    width: 60%;
    color: ${props => props.theme.colors.white};
  }
  .footer-content p {
    line-height: 0.5rem;
    min-height: 1rem;
    margin-bottom: 0.5rem;
  }
  a[href^="tel"] {
    color: inherit;
    text-decoration: none;
  }
`;

const StyledButton = styled.button`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.darkBlue};
  padding: 10px 30px 10px 30px;
  border: 1px solid ${props => props.theme.colors.white};
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition-duration: ${props => props.theme.transitionDuration};
  transition-duration: ${props => props.theme.transitionDuration};
  transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  margin-top: 2rem;
  margin-right: 1rem;
  &:hover {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.darkBlue};
  }
`;

const SocialMedia = styled.div`
  margin-top: 1rem;
  a {
    margin-right: 1rem;
    color: ${props => props.theme.colors.white};;
  }
  a:hover {
    color: ${props => props.theme.colors.orange};;
  }
  svg {
    width: 1em;
    height: 1em;
  }
`;

const StyledLink = styled(Link)`
  margin-top: 2rem;
  font-style: normal;
`;

class Footer extends Component {
  render() {
    const { children, socialMedia } = this.props;
    return (
      <StyledFooter id='footer'>
        <Wrapper>
          <StyledTitle>LET'S GET COFFEE AND CHAT</StyledTitle>
          <FooterSection>
            <ContactInformation>
              <span className='footer-content'>{children}</span>
              <SocialMedia>
                <p style={{ marginTop: '2rem'}}>Follow us:</p>
                <a href={socialMedia.linkedin.url} target='_blank' rel="noreferrer" aria-label="Linkedin icon"><FontAwesomeIcon icon={faLinkedinIn} size='lg'/></a>
                <a href={socialMedia.twitter.url} target='_blank' rel="noreferrer" aria-label="Twitter icon"><FontAwesomeIcon icon={faTwitter} size='lg'/></a>
                <a href={socialMedia.instagram.url} target='_blank' rel="noreferrer" aria-label="Instagram icon"><FontAwesomeIcon icon={faInstagram} size='lg'/></a>
              </SocialMedia>
              <StyledLink to='/contact'><StyledButton>CONTACT</StyledButton></StyledLink>
            </ContactInformation>
          </FooterSection>
        </Wrapper>
      </StyledFooter>
    );
  }
}

export default Footer;

Footer.propTypes = {
  children: PropTypes.node.isRequired
};
